import { Link } from '@tanstack/react-router'
import type { SVGProps } from 'react'

import { AdminNavItems, type NavItem } from '@/config/nav'
import { useIsActive } from '@/hooks/useIsActive'
import { cn } from '@/lib/utils'

type NavItemProps = {
  to: string
  label: string
  icon: (props: SVGProps<SVGSVGElement>) => React.ReactNode
  iconActive?: (props: SVGProps<SVGSVGElement>) => React.ReactNode
}

const NavItem = ({ to, icon, iconActive = icon, label }: NavItemProps) => {
  const isActive = useIsActive(to)

  const Icon = isActive ? iconActive : icon

  return (
    <Link
      to={to}
      className={cn(
        'flex flex-1 flex-col items-center justify-center transition-colors',
        isActive ? 'text-primary' : 'text-muted-foreground',
      )}
    >
      <Icon className="size-6.5" />
      <div className="text-[10px] font-bold uppercase">{label}</div>
    </Link>
  )
}

type DashboardNavigationBarProps = {
  items: NavItem[]
}

export const DashboardNavigationBar = ({
  items = AdminNavItems,
}: DashboardNavigationBarProps) => {
  return (
    <div className="pb-safe border-border/50 border-t bg-white/80 backdrop-blur-lg">
      <div className="h-bnav flex">
        {items.map((item) => (
          <NavItem
            key={item.to}
            to={item.to}
            label={item.label}
            icon={item.icon}
            iconActive={item.iconActive}
          />
        ))}
      </div>
    </div>
  )
}
